// extracted by css-extract-rspack-plugin
export default {"rejectedBanner":"uixm8RF8ouEMAKU5"};